import CardRow from "components/card/CardRow";
import StoryLinkCard from "components/card/StoryLinkCard";

const RecommendedStories = ({ blogs, cardRowRef }) => {
  const storyCards = blogs.map((story) => (
    <StoryLinkCard
      key={`recommended-${story.id}`}
      story={story}
      maxTitleLength={40}
    />
  ));
  return (
    <CardRow
      sectionTitle="Recommended Reading"
      cards={storyCards.slice(0, 3)}
      sideScroll="all"
      sideScrollButtons={true}
      scrollAfterCardsCount={2}
      sectionSlug="/stories"
      ref={cardRowRef}
    />
  );
};

export default RecommendedStories;
